export default __webpack_public_path__ + "static/0032-4959895911014576c331c80d42ee0b2d.png";